import { Injectable, Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { DataListCommandFilterType } from '@shared/components/data-list/common';
import { ItvDatePipe } from '@shared/pipes';

@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'dataListFilterPipe',
  // TODO: this re-renders the pipe when filter.values has changed. It's not very heavy, but we need a better solution
  pure: false,
})
export class DataListFilterPipe implements PipeTransform {
  translate = inject(TranslateService);
  itvDatePipe = inject(ItvDatePipe);

  /**
   * Transform filters input to display in summary
   *
   * @param {(string | string[])} value Can be:
   *  string (basic input | single selection | date input) or
   *  string[] (multiple select | range)
   * @param {DataListCommandFilterType} filter
   * @returns {string}
   */
  transform(value: string | string[], filter: DataListCommandFilterType): string {
    if (typeof value === 'string') {
      if (filter.type === 'date') return this.itvDatePipe.transform(value);
      if (filter.values) return filter.values.find(f => f.key === value).value;
      return value;
    }
    if (typeof value === 'number' || typeof value === 'boolean') {
      return this.translate.instant(filter.values.find(f => f.key === value)?.value ?? value);
    } else if (filter.values) {
      return value.map(val => this.translate.instant(filter.values.find(f => f.key === val).value)).join(', ');
    } else if (filter.type === 'date') {
      if (Array.isArray(value) && value.length) {
        return `${this.itvDatePipe.transform(value[0])} - ${this.itvDatePipe.transform(value[1])}`;
      } else if (!Array.isArray(value)) {
        return this.itvDatePipe.transform(value);
      }
    } else {
      return value as never;
    }
  }
}
